const resource = '/shop-api/price'

export default (ctx, $axios) => ({
  get (sku, currency, accountNo) {
    return $axios.$get(`${resource}/${sku}/${currency}/${accountNo}`)
  },
})